// The six entries shown when the Where box is empty — identical on phone and
// desktop. Place IDs are stable and may be stored under Google's terms, so one
// tap costs a single Place Details call.
export const DEFAULT_PLACES = [
  { place_id: "ChIJ_zORfyhaWjcRMt5rQzITvSs", main: "Guwahati", secondary: "Assam, India", tag: "Gateway to the Northeast", tint: "bg-sky-50 text-sky-600" },
  { place_id: "ChIJVz2vJLT7RDcRYhNwLU9RFk0", main: "Kaziranga National Park", secondary: "Assam, India", tag: "Wildlife & tea estates", tint: "bg-emerald-50 text-emerald-600" },
  { place_id: "ChIJY-aE-GCORjcRhjT9nJbzQ88", main: "Golaghat", secondary: "Assam, India", tag: "Homestays by the tea gardens", tint: "bg-lime-50 text-lime-700" },
  { place_id: "ChIJoYtR7pTCRjcRvAZkx_J_FHU", main: "Jorhat", secondary: "Assam, India", tag: "Cultural capital near you", tint: "bg-amber-50 text-amber-600" },
  { place_id: "ChIJfyC9NI9-UDcRK4iPEPctSGI", main: "Shillong", secondary: "Meghalaya, India", tag: "For nature lovers", tint: "bg-violet-50 text-violet-600" },
];

export const newPlaceSession = () =>
  (window.crypto?.randomUUID?.() || `${Date.now()}${Math.random().toString(16).slice(2)}`);

export const NEAR_RADIUS_KM = 75;

// Google's pin for Kaziranga National Park sits at the park's western tip, so a
// guest picking the park is measured from Kohora, the main (central range) gate.
// Only place IDs are stored here — never coordinates.
export const KOHORA_PLACE_ID = "ChIJQY_SJu1HRDcRD5yhGvTZ9Pg";
export const KAZIRANGA_LABEL = "Kaziranga National Park";

// True only for a pick that means the park / Kaziranga itself. A specific spot
// inside it ("Western Range (Elephant Safari Point)", "animal corridor start")
// keeps its own pin.
const kazirangaArea = (t) => {
  if (!/kaziranga/i.test(t || "")) return false;
  const rest = String(t)
    .toLowerCase()
    .replace(/kaziranga/g, " ")
    .replace(/national park|wildlife sanctuary|tiger reserve|\bnp\b|\bthe\b|\band\b/g, " ")
    .replace(/[^a-z]+/g, " ")
    .trim();
  return rest === "";
};

export const isKazirangaPick = (...texts) => texts.filter(Boolean).some(kazirangaArea);

export const kmLabel = (km) => {
  if (km == null || !isFinite(km)) return null;
  return km < 1 ? "Under 1 km" : `${Math.round(km)} km`;
};

// "40 km from Kaziranga" / "12 km away" / "Under 1 km from Sohra"
export const distanceLabel = (km, placeName) => {
  const base = kmLabel(km);
  if (!base) return null;
  if (!placeName) return base === "Under 1 km" ? "Under 1 km away" : `${base} away`;
  return `${base} from ${placeName}`;
};

const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

// A stay counts as "near" a state/district pick when it sits inside it;
// otherwise when it's within the radius.
export const isNear = (focus, geo, km) => {
  if (!geo) return false;
  if (focus?.kind === "state" && focus.state && geo.state) return norm(geo.state) === norm(focus.state);
  if (focus?.kind === "district" && focus.district && geo.district) return norm(geo.district) === norm(focus.district);
  return isFinite(km) && km <= NEAR_RADIUS_KM;
};
